import { Pipe, PipeTransform, inject } from '@angular/core';
import { UserRolesAndPermissionsService } from '@core/services/user-roles-and-permissions.service';
import { RolesAndPermissions } from '@shared/constants/roles-and-permissions';
import { VtFilterMenuItemType } from '@shared/constants/vt-filter-menu-item-type';
import { VtFilter } from '@shared/interfaces/vt-filter-menu-item';

/** Pipe takes in data filters array and toggles filter menu items dpeending on
 * the presence of FilterEditExtended permission
 */
@Pipe({
  name: 'vtFilterPermissions',
  standalone: false,
})
export class VtFilterPermissionsPipe implements PipeTransform {
  private rolesAndPermissionsService = inject(UserRolesAndPermissionsService);

  private toggleableMenuItemTypes = [
    VtFilterMenuItemType.Add,
    VtFilterMenuItemType.Delete,
    VtFilterMenuItemType.Edit,
    VtFilterMenuItemType.Update,
  ];

  transform<T extends VtFilter>(data: T[]): T[] {
    const hasPermission = this.rolesAndPermissionsService
      .getPermissionsArray()
      ?.includes(RolesAndPermissions.FilterEditExtended);

    if (hasPermission) return data;

    return data.map(dataFilter => ({
      ...dataFilter,
      filterMenuItems: dataFilter.filterMenuItems.map(item => ({
        ...item,
        disabled:
          dataFilter.type === 'global' &&
          this.toggleableMenuItemTypes.includes(item.itemType) &&
          !hasPermission,
      })),
    }));
  }
}
